<form (ngSubmit)="changePassword()" [formGroup]="changePasswordForm">
	<div class="modal-header">
		<h5 class="modal-title" id="modal-basic-title">Change Password</h5>
		<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="text-center">
			<u>Password Requirements</u><br/>
			Must be at least 10 characters in Length.<br/>
			Cannot match any of the passwords in our list of commonly used passwords.<br/>
		</div>
		<div class='row'>	
			<pcg-show-hide-password class="col-sm-12" fcName="currentPassword" [parentForm]="changePasswordForm" label="Current Password" inputCssClass="form-control"></pcg-show-hide-password>
		</div>
		<div class='row'>			
			<pcg-show-hide-password class="col-sm-12" fcName="password" [parentForm]="changePasswordForm" label="New Password" inputCssClass="form-control"></pcg-show-hide-password>
		</div>
		<div class='row'>			
			<pcg-show-hide-password class="col-sm-12" fcName="confirmPassword" [parentForm]="changePasswordForm" label="Confirm New Password" inputCssClass="form-control"></pcg-show-hide-password>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-cancel btn-lg" (click)="activeModal.dismiss()">Cancel</button>
		<button type="submit" class="btn btn-save btn-lg">Change Password</button>
	</div>
</form>
